/* THIS IS A BIT-AUTO-GENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. */

Object.defineProperty(exports, "__esModule", { value: true });
module.exports = require('@bit/marccoet.toile.use-resize-observer');